import { LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { ErrorFallback } from 'modules/App/ErrorFallback';
import { getLegalClientFirstHeadMainInfo } from 'modules/client/legalClientFirstHead/helpers/getLegalClientFirstHeadMainInfo';

import { useLegalClientFirstHead } from '../hooks';
import { LegalClientFirstHeadView } from '../views/LegalClientFirstHeadView';

export const LegalClientFirstHeadContainer = () => {
  const {
    loading,
    legalClientFirstHead,
    legalClientLegalHead,
    countries,
    countriesLoading,
    error,
    initialValues,
    submitLoading,
    breadcrumbsTitles,
    resendVerificationEmailTime,
    changeEmailLoading,
    changeEmailError,
    deleteLoading,
    archiveLoading,
    dearchiveLoading,
    revokeOtpVerificationLoading,
    onChangeEmail,
    lockClientIfPossible,
    unlockClient,
    onSubmit,
    onShowVersionHistory,
    onSendVerificationEmail,
    onDelete,
    onArchive,
    onDearchive,
    onRevokeOtpVerification,
  } = useLegalClientFirstHead();

  useScrollToTop([]);

  if (error || (!legalClientFirstHead && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !legalClientFirstHead) {
    return <LoadingLayout />;
  }

  const mainInfo = getLegalClientFirstHeadMainInfo(legalClientFirstHead);

  return (
    <LegalClientFirstHeadView
      archiveLoading={archiveLoading}
      breadcrumbsTitles={breadcrumbsTitles}
      changeEmailError={changeEmailError}
      changeEmailLoading={changeEmailLoading}
      countries={countries}
      countriesLoading={countriesLoading}
      dearchiveLoading={dearchiveLoading}
      deleteLoading={deleteLoading}
      initialValues={initialValues}
      isLegalClientArchived={legalClientLegalHead?.archived}
      kycData={legalClientFirstHead.kyc}
      lockClientIfPossible={lockClientIfPossible}
      mainInfo={mainInfo}
      resendVerificationEmailTime={resendVerificationEmailTime}
      revokeOtpVerificationLoading={revokeOtpVerificationLoading}
      submitLoading={submitLoading}
      unlockClient={unlockClient}
      onArchive={onArchive}
      onChangeEmail={onChangeEmail}
      onDearchive={onDearchive}
      onDelete={onDelete}
      onRevokeOtpVerification={onRevokeOtpVerification}
      onSendVerificationEmail={onSendVerificationEmail}
      onShowVersionHistory={onShowVersionHistory}
      onSubmit={onSubmit}
    />
  );
};
